import React from 'react'

import Layout from '../components/Layout'
import SEO from '../components/seo'
import AboutHero from '../components/AboutHero'

const AboutPage = () => (
  <Layout>
    <SEO
      title="About the Author"
      keywords={[`Shenanigans`, `Trina Vargo`, `US-Ireland`, `US-IA`, `USIA`]}
    />
    <AboutHero />
  </Layout>
)

export default AboutPage
